<template>
  <div class="container">
    <b-modal
        :model-value="modCrearMenu"
        :no-close-on-backdrop="true"
        hide-footer
        hide-header-close
        centered
        :title="labels.title"
        header-class="reset-modal-header"
        title-class="reset-modal-title"
        body-class="reset-modal-body"
        class="reset-password-dialog"
    >
        <div class="uniform-modal-body">
            <div class="password-policy-box mb-3">
                <div class="password-policy-title">{{ labels.infoTitle }}</div>
                <div class="password-policy-item">{{ labels.infoText }}</div>
            </div>
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <h5>{{labels.name}}</h5> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <input type="text" v-model="nombre" class="form-control reset-input">
                </b-col>
            </b-row>
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <h5>{{labels.ruta}}</h5> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <input type="text" v-model="ruta" class="form-control reset-input">
                </b-col>
            </b-row>
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <h5>{{labels.icono}}</h5> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-select
                        v-model="icono"
                        :options="iconSelectOptions"
                        class="form-control reset-input"
                    />
                </b-col>
            </b-row>
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <h5>{{labels.orden}}</h5> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <input type="text" v-model="orden" class="form-control reset-input">
                </b-col>
            </b-row>
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <h5>{{labels.roles}}</h5> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <md-field>
                        <md-select v-model="rolSelected" name="roles" id="roles" md-dense multiple>
                            <md-option v-for="rol in roles" :key="rol?.id" :value="rol?.id">{{ rol?.nombre }}</md-option> 
                        </md-select>
                    </md-field>
                </b-col>
            </b-row>
            <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                <b-button class="mr-2 reset-btn-secondary" @click="cierraModal">{{ labels.close }}</b-button>
                <b-button class="reset-btn-primary" @click="guardarMenu">{{ labels.save }}</b-button>
            </div>
        </div>
    </b-modal>
  </div>
</template>
<script>
import Menu from '../../../services/Menu'; 
import Roles from '../../../services/Roles'; 
import { getMenuIconNames } from '../../../utils/menuIconCatalog';

export default {
    name:"CrearMenu",
    props:['modCrearMenu'],
    data: () => ({
        nombre : "",
        ruta : "",
        icono : "",
        orden : "",
        roles : [],
        rolSelected : [],
        iconOptions: []
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Crear menú",
                    save : "Guardar",
                    close : "Cerrar",
                    name : "Nombre:",
                    ruta : "Ruta:",
                    icono : "Icono:",
                    roles : "Roles:",
                    orden : "Orden:",
                    infoTitle: "Datos del menú",
                    infoText: "Completa la información y guarda el nuevo menú."
                }
            }else{
                return {
                    title: "Create menu",
                    save : "Save",
                    close : "Close",
                    name : "Name:",
                    ruta : "Route:",
                    icono : "Icon:",
                    roles : "Role:",
                    orden : "Order:",
                    infoTitle: "Menu information",
                    infoText: "Complete the information and save the new menu."
                }
            }
        },
        iconSelectOptions() {
            const base = this.$store.state._language == "es-ES"
                ? [{ value: "", text: "Seleccione un icono" }]
                : [{ value: "", text: "Select an icon" }];
            const items = this.iconOptions.map((iconName) => ({
                value: iconName,
                text: iconName
            }));
            return [...base, ...items];
        }
    },
    methods:{
        cierraModal(){
            // console.log("CierraModal") 
            this.$emit('closeModal',false) 
        },
        guardarMenu(){
            // console.log("guardaMenu",this.roles) 
            if(this.nombre == ""){ 
                this.$toast.error(`Diligenciar el campo Nombre`) 
            
            }else if(this.ruta == ""){ 
                this.$toast.error(`Diligenciar el campo Ruta`) 
            
            }else if(this.icono == ""){ 
                this.$toast.error(`Diligenciar el campo Icono`) 

            }else if(this.orden == ""){ 
                this.$toast.error(`Diligenciar el campo Orden`) 
            
            }else if(this.rolSelected.length == 0){ 
                this.$toast.error(`Seleccionar minimo un Rol`) 
            
            }else{
                let formu = {
                    'nombre' : this.nombre, 
                    'ruta' : this.ruta, 
                    'icono' : this.icono, 
                    'roles' : this.rolSelected, 
                    'orden' : this.orden, 
                    'idUser' : this.$store.state.userId 
                }
                // console.log(formu) 

                Menu.createMenu(formu) 
                .then((res) => { 
                    // console.log(res) 
                    if(res.status == 200){ 
                        this.$toast.success(res.data.message) 
                        location.reload(); 
                    
                    }else if(res.status == 204){ 
                        this.$toast.error("El menú ingresado ya existe") 
                    }
                })
                .catch((err) => { 
                    console.log(err) 
                })
            }
        }
    },
    mounted(){
        this.iconOptions = getMenuIconNames();
        Roles.getAllRoles() 
        .then((res) => { 
            // console.log(res.data.roles) 
            this.roles = res.data.roles 
        })
        .catch((err) => { 
            console.log(err) 
        })
    }
}
</script>

<style>

</style>
